import React, { Suspense, useContext } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import Error404 from "../404";
import { store } from "../components/Store";
import { LoadingSpinner } from "../components/loading-spinner";
import { usePersonalAccountPermissions } from "../hooks/use-personal-account-permissions";

const Lazy = {
	EditProfile: React.lazy(() => import("./edit-profile")),
	EditPassword: React.lazy(() => import("./edit-password")),
	Institutions: React.lazy(() => import("./institutions")),
	InstitutionConnection: React.lazy(() => import("./institution-connection")),
};
export const PersonalAccountDashboardRouter = () => {
	const appStore = useContext(store);
	const location = useLocation();
	const pathname = location.pathname;
	const state = appStore?.state;
	const mainDataLoaded = state?.mainDataLoaded;
	const isAuth = state?.sesionActiva === "SI";
	const personalAccountPermissions = usePersonalAccountPermissions();
	const canViewAccount = personalAccountPermissions.hasPermission("view");
	const canEditAccount = personalAccountPermissions.hasPermission("edit");
	const publicRoutes = [
		"/perfil/institucion/asociar/success",
		"/perfil/institucion/asociar/error",
	];

	if (mainDataLoaded && !isAuth) {
		return <Redirect to="/" />;
	}
	if (mainDataLoaded && isAuth && (!canViewAccount || !canEditAccount) && !publicRoutes.includes(pathname)) {
		return <Redirect to="/" />;
	}

	return (
		<div className="personal-account-dashboard">
			<div className="bg-background-shape"></div>
			<div className="container p-0 d-flex-column d-lg-flex py-5 p-2">
				<div className="surface--bg container main-content p-3 p-lg-5 mx-auto ">
					<Suspense
						fallback={
							<div className="w-100 d-flex justify-content-center">
								<LoadingSpinner size={40} className={"onbackground--color m-3"} />
							</div>
						}
					>
						<Switch>
							<Route
								exact
								path="/perfil"
								render={() => <Redirect to="/perfil/editar" />}
							/>
							<Redirect exact from="/perfil" to="/perfil/editar" />
							<Route exact path="/perfil/editar" component={Lazy.EditProfile} />
							<Route
								exact
								path="/perfil/editar/password"
								component={Lazy.EditPassword}
							/>
							<Route exact path="/perfil/institucion" component={Lazy.Institutions} />
							<Route  path="/perfil/institucion/asociar" component={Lazy.InstitutionConnection} />
							<Route component={Error404} />
						</Switch>
					</Suspense>
				</div>
			</div>
		</div>
	);
};
